import { render, staticRenderFns } from "./flowData.vue?vue&type=template&id=a31622fa&scoped=true&"
import script from "./flowData.vue?vue&type=script&lang=js&"
export * from "./flowData.vue?vue&type=script&lang=js&"
import style0 from "./flowData.vue?vue&type=style&index=0&id=a31622fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31622fa",
  null
  
)

export default component.exports